import { useCallback, useEffect, useState } from 'react';
import { buildAgentSidePanels } from '../services/agentSidePanelsBuilder';

const EMPTY_PANELS = {};

export default function useAgentSidePanels(moduleId) {
  const [panels, setPanels] = useState(EMPTY_PANELS);
  const [counts, setCounts] = useState({});
  const [recentDocuments, setRecentDocuments] = useState([]);
  const [paymentGroups, setPaymentGroups] = useState([]);
  const [paymentCount, setPaymentCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const refreshPanels = useCallback(async () => {
    if (!moduleId) {
      setPanels(EMPTY_PANELS);
      setCounts({});
      setRecentDocuments([]);
      setPaymentGroups([]);
      setPaymentCount(0);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    try {
      const data = await buildAgentSidePanels(moduleId);
      setPanels(data.panels || EMPTY_PANELS);
      setCounts(data.counts || {});
      setRecentDocuments(data.recentDocuments || []);
      setPaymentGroups(data.paymentGroups || []);
      setPaymentCount(data.paymentCount || 0);
    } finally {
      setIsLoading(false);
    }
  }, [moduleId]);

  useEffect(() => {
    refreshPanels();
  }, [refreshPanels]);

  return {
    panels,
    counts,
    recentDocuments,
    paymentGroups,
    paymentCount,
    isPanelsLoading: isLoading,
    refreshPanels,
  };
}
